$(document).ready(function () { /* --s-- */
    var txt = $('.jdgm-carousel-item__review-body').find('p').text();
    if (txt.length > 150) 
        $('.jdgm-carousel-item__review-body').find('p').text(txt.substring(0, 80) + '...');
    
});

$(document).ready(function () {

    var width = $(window).width();
    console.log(width);
    if (width <= 768) {
         $('#slider_mob').flickity({
            cellAlign: 'left',
            contain: true,
            autoPlay: true,
            prevNextButtons: false,
            draggable: true,
            pageDots: false
        });
    } else {
       $('#slider_mob').flickity('destroy');
    }
})
$(window).on('resize', function () {
    var win = $(this); // this = window
    if (win.width() <= 768) {
        $('#slider_mob').flickity({
            cellAlign: 'left',
            contain: true,
            autoPlay: true,
            prevNextButtons: false,
            draggable: true,
            pageDots: false
        });
    } else {
        $('#slider_mob').flickity('destroy');
    }
});


